import React from "react";
import { useState } from "react";
import { api } from 'api';

/**
 * Hook para realizar peticiones a la API relacionadas a las recepciones con contenedores.
 * @returns {Object} Objeto con las funciones y estados necesarios para las recepciones con contenedores.
 */
export const CrearRecepcionesApi = () => {
    const [cargando, setCargando] = useState(false);
    const [cargandoGuardado, setCargandoGuardado] = useState(false);

    // VEHICULOS
    const [vehiculos, setVehiculos] = useState([]);

    const getVehiculos = async (inputValue) => {
        try {
            // setCargando(true);
            // const response = await api.get(`vehiculo`, { search: inputValue || '' });
            const response = await api.get('recepciones_contenedores/get_vehiculos', { search: inputValue || '' });
            if (!response.results) return [];
            const data = response.results;
            const dataForSelect = data.map(vehiculo => ({ value: vehiculo.id, label: vehiculo.nombre }));

            setVehiculos(dataForSelect)
            return dataForSelect;
        } catch (error) {
            console.error(error);
            setVehiculos([]);
            return [];
        } finally {
            setCargando(false);
        }
    }



    // PILOTOS
    const [pilotos, setPilotos] = useState([]);

    const getPilotos = async (inputValue) => {
        try {
            // setCargando(true);
            const response = await api.get('piloto', { search: inputValue || '' });
            if (!response.results) return [];
            const data = response.results;
            const dataForSelect = data.map(piloto => ({ value: piloto.id, label: piloto.nombre }));

            setPilotos(dataForSelect)
            return dataForSelect;
        } catch (error) {
            console.error(error);
            setPilotos([]);
            return [];
        } finally {
            setCargando(false);
        }
    }

    // GUARDAR RECEPCIONES
    const guardarRecepciones = async (payload) => {
        try {
            setCargandoGuardado(true);
            const response = await api.post('recepciones_contenedores/ingreso_contenedores/', payload);

            return response;
        } catch (error) {
            return error;
        } finally {
            setCargandoGuardado(false);
        }
    }

    return {
        getVehiculos,
        vehiculos,

        getPilotos,
        pilotos,

        guardarRecepciones,

        cargando,
        cargandoGuardado,
    }
}
